import React from 'react'

const TabContent = ({ isActive, backgroundUrl, iconUrl, title, subTitle, mainText, mainText2, buttonText, buttonUrl })  => {
    
    return (
        <div className={`tabContent ${ isActive ? "active" : "" }`}>
            <div className="contentImage" style={{ backgroundImage: `url('${ backgroundUrl }')` }}></div>
            <div className="content">
                <img src={iconUrl}
                     alt={title}
                     className="contentTopIcon"/>
                <h3 className="bold">{title}</h3>
                { subTitle != undefined ?
                    <p className="bold">{subTitle}</p>
                    :
                    ""
                }
                <p>{mainText}</p>
                { mainText2 != undefined ?
                    <p>{mainText2}</p>
                    :
                    ""
                }
                { buttonText != undefined && buttonUrl != undefined ?
                    <a className="btn" href={buttonUrl}>{buttonText}</a>
                    :
                    ""
                }
            </div>
        </div>
    )
}

export default TabContent;